"use client";

import React from "react";
import type { VideoSectionData } from "@/types/cms";
import { useSectionTracking } from "@/lib/analytics/use-section-tracking";

interface VideoSectionProps {
  data: VideoSectionData;
}

export default function VideoSection({ data }: VideoSectionProps) {
  const sectionRef = useSectionTracking("Video Section", "video");
  const videoSrc = data.videoFile?.url || data.videoUrl || "";

  return (
    <section
      ref={sectionRef as React.RefObject<HTMLElement>}
      className="w-full py-16 px-4 bg-black"
    >
      <div className="max-w-6xl mx-auto">
        <video
          className="w-full rounded-3xl shadow-2xl"
          autoPlay={data.autoPlay}
          muted={data.muted}
          loop={data.loop}
          playsInline
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
}
